import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, " Preisrechner ", -1)
const _hoisted_3 = { class: "row g-3 g-xl-4" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = {
  key: 0,
  class: "col-12"
}
const _hoisted_6 = {
  key: 1,
  class: "col-8"
}
const _hoisted_7 = {
  key: 2,
  class: "col-4"
}
const _hoisted_8 = {
  key: 3,
  class: "col-12"
}
const _hoisted_9 = {
  key: 4,
  class: "col-12"
}
const _hoisted_10 = {
  key: 5,
  class: "col-12"
}
const _hoisted_11 = {
  key: 6,
  class: "col-12 counterTypesUsage"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "double" }, " HT ", -1)
const _hoisted_13 = {
  key: 7,
  class: "col-12 counterTypesUsage"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "double" }, " NT ", -1)
const _hoisted_15 = {
  key: 8,
  class: "col-12"
}
const _hoisted_16 = {
  key: 9,
  class: "col-12"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("small", { class: "m-0" }, " Für die Berechnung Deines Wunschtarifs benötigen wir noch Deine Straße und Hausnummer. ", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "col-12" }

import IoProducts from '@/api/IoProductAPI';
import BaseCalculatorV2BranchSelect from '@/components/BaseCalculatorV2/BaseCalculatorV2BranchSelect.vue';
import BranchInterface from '@/interfaces/BranchInterface';
import {
  reactive,
  computed,
  watch,
  nextTick,
  ref,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
} from 'vue';
import { EnetAPI, ProductAPI } from '@/api';
import BaseSpacer from '@/components/BaseSpacer.vue';
import BaseButton from '@/components/BaseButton.vue';
import Checkbox from '@/components/Checkbox.vue';
import InputField from '@/components/InputField.vue';
import SelectField from '@/components/SelectField.vue';
import BaseCalculatorUsageField from '@/components/BaseCalculator/BaseCalculatorUsageField.vue';
import CityInterface from '@/interfaces/CityInterface';
import StreetInterface from '@/interfaces/StreetInterface';
import ProductPost from '@/interfaces/ProductPostInterface';
import { useStore } from 'vuex';
import Tooltip from '@/components/Tooltip.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCalculatorV2',
  props: {
  productId: {
    type: [String, Number],
    default: null,
  },
  showProductName: {
    type: [String, Number, Boolean],
    default: true,
  },
  branches: [String, Array],
  postcode: {
    type: [String, Number],
    default: null,
  },
  preselectedOptions: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: () => 'standalone',
    validator: (type: string) => ['standalone', 'component'].indexOf(type) !== -1,
  },
  buttonLabel: {
    type: String,
    default: () => 'Preis anzeigen',
  },
  labelExtra: {
    type: String,
    default: null,
  },
  heroLayout: {
    type: Boolean,
    default: () => false,
  },
  affiliateId: {
    type: String,
    default: () => '',
  },
  lz: {
    type: String,
    default: () => '',
  },
  pg: {
    type: String,
    default: () => '',
  },
  epu: {
    type: String,
    default: () => '',
  },
  pid: {
    type: String,
    default: () => '',
  },
},
  emits: [
  'changeUsageIcon',
],
  setup(__props, { emit }) {

const props = __props;

library.add(faCircleInfo);





const branchSelection = ref<InstanceType<typeof BaseCalculatorV2BranchSelect>>();
const store = useStore();
const root = ref<InstanceType<typeof HTMLElement>>();
const branchesEl = ref<InstanceType<typeof HTMLElement>>();
const postcodeError = reactive({ value: null as string | null });

const calculatorBranches = computed(() => (Array.isArray(props.branches)
  ? props.branches
  : props.branches?.split(',')));

const product = ref<ProductPost | null>(null);

const branches = computed(() => store.getters['branches/forCalculatorV2']);
const branchOptions = computed<BranchInterface[]>(() => branches.value
  .filter((branch: BranchInterface) => (
    Array.isArray(calculatorBranches.value) ? calculatorBranches.value.includes(branch.slug) : true
  )));

const preselectedOptions: Record<string, unknown> = {
  productId: props.productId ? parseInt(props.productId as string, 10) : null,
  branch: null,
  postcode: (props.postcode !== null ? parseInt(`${props.postcode}`, 10) : null),
  city: null,
  street: null,
  houseNumber: null,
  usage: null,
  usageHt: null,
  usageNt: null,
  business: false,
  oeko: false,
  heating: null,
  typeOfMeasurement: null,
};

Object.keys(preselectedOptions)
  .forEach((key) => {
    if (props.preselectedOptions && props.preselectedOptions[key]) {
      preselectedOptions[key] = props.preselectedOptions[key];
    }
  });

const initialBranch = branchOptions.value.find((b: BranchInterface) => b.slug === preselectedOptions.branch) || branches.value[0];
const options = reactive({
  productId: preselectedOptions.productId,
  branch: initialBranch,
  postcode: preselectedOptions.postcode,
  postcodeLoaded: '',
  pricesExists: {
    for: '',
    value: {
      postcode: true,
      street: !!preselectedOptions.street,
      networkNumber: !!preselectedOptions.networkNumber,
    },
  },
  initialStreet: !!preselectedOptions.street,
  showStreetMessage: false,
  isFetching: false,
  preselectedPostcodeSet: false,
  selectableCities: [] as CityInterface[],
  selectableStreets: [] as StreetInterface[],
  city: preselectedOptions.city || null as string | null,
  street: preselectedOptions.street || null as string | null,
  houseNumber: preselectedOptions.houseNumber as string | null,
  usage: preselectedOptions.usage || undefined,
  usageHt: preselectedOptions.usageHt || undefined,
  usageNt: preselectedOptions.usageNt || undefined,
  business: preselectedOptions.business as boolean,
  oeko: preselectedOptions.oeko as boolean,
  heating: preselectedOptions.heating as string | null,
  typeOfMeasurement: preselectedOptions.typeOfMeasurement as string | null,
});

const needsAddress = computed(() => options.pricesExists.value.street || options.pricesExists.value.networkNumber);

watch(() => needsAddress.value, (val) => {
  if (!options.initialStreet) {
    options.showStreetMessage = val;
  }
});

const fetchCitiesAndStreets = ($postcode: string | number) => {
  if (`${$postcode}`.length === 5 && $postcode !== options.postcodeLoaded) {
    options.selectableCities = [];
    options.selectableStreets = [];

    options.postcodeLoaded = $postcode as string;
    postcodeError.value = null;

    EnetAPI.getCitiesAndStreets($postcode)
      .then((data) => {
        options.selectableCities = data.cities;
        options.selectableStreets = data.streets;
        if (!(preselectedOptions.postcode === $postcode && !options.preselectedPostcodeSet)) {
          options.city = options.selectableCities[0].id;
          options.street = options.selectableStreets[0].id;
          options.preselectedPostcodeSet = true;
        }
      }).catch(() => {
        postcodeError.value = 'Ungültige Postleitzahl';
      });
  }
};

watch(() => options.postcode, ($newPostcode) => {
  fetchCitiesAndStreets($newPostcode as string);
});

if (`${options.postcode || ''}`.trim().length === 5) {
  fetchCitiesAndStreets(options.postcode as string);
}

const getCitiesOptions = ($cities: CityInterface[]) => [...$cities].map(($c) => ({
  label: $c.name,
  value: $c.id,
}));

const streetsOptions = computed(() => [...options.selectableStreets].map(($s) => ({
  label: $s.name,
  value: $s.id,
})));

const categoryDisplayNames = {
  waermepumpe: 'Wärmepumpe',
  speicherheizung: 'Speicherheizung',
};

const heatOptions = computed(() => {
  if (options.branch.name === 'Heizstrom') {
    return options.branch.categories.map((c: string | number) => ({
      label: categoryDisplayNames[c] || c,
      value: c,
    }));
  }
  return [];
});

const isHeatingPower = computed(() => options.branch.mainCategory.key === 'heatingPower');

const singleCounterSvg = `${window.ioappConfig.themeUri}/assets/img/singleCounter.svg`;
const DoubleCounterSvg = `${window.ioappConfig.themeUri}/assets/img/doubleCounter.svg`;

const typeOfMeasurementOptions = ref([]);

watch(() => options.heating, (newVal) => {
  typeOfMeasurementOptions.value = [];

  const staticOptions = [
    { label: 'Eintarifzähler ohne Haushaltsstrom', value: 'single', image: singleCounterSvg },
    { label: 'Zweitarifzähler ohne Haushaltsstrom', value: 'doubleTariffWithoutHouseholdPower', image: DoubleCounterSvg },
  ];

  typeOfMeasurementOptions.value.push(...staticOptions);

  if (newVal === 'speicherheizung') {
    const labelToAdd = {
      label: 'Zweitarifzähler inklusive Haushaltsstrom',
      value: 'doubleTariffWithHouseholdPower',
      image: DoubleCounterSvg,
    };
    if (!typeOfMeasurementOptions.value.find((option) => option === labelToAdd.value)) {
      typeOfMeasurementOptions.value.push(labelToAdd);
    }
  }
}, {
  immediate: true,
  deep: true,
});

const canSubmit = computed(() => `${options.postcode || ''}`.trim().length === 5
    && options.city !== null
    && (needsAddress.value ? (
      options.street !== null && `${options.houseNumber || ''}`.trim().length >= 1
    ) : true)
    && parseInt(`${options.usage || (options.usageHt && options.usageNt) || '0'}`, 10) > 0);

const getPriceExists = async () => {
  const params: Record<string, any> = {
    customerType: options.business ? 'business' : 'private',
    usage: options.usage || options.usageNt,
    usageHt: options.usageHt,
    postcode: options.postcode,
    city: options.city,
  };

  if (options.branch) {
    params.categories = [options.branch.mainCategory.key];
  }

  const currentForKey = JSON.stringify(params);

  if (options.pricesExists.for !== currentForKey && canSubmit.value) {
    options.isFetching = true;

    await IoProducts.getPriceExists(params)
      .then((pricesExist) => {
        options.pricesExists.for = currentForKey;
        options.pricesExists.value = pricesExist;
      })
      .finally(() => {
        options.isFetching = false;
      });
  }
};

const emitChangeIcon = (icon: number) => {
  emit('changeUsageIcon', icon);
};

onMounted(() => {
  getPriceExists();
});

const submit = async () => {
  const path = `${window.ioappConfig.shopUrl}preisanzeige`;

  const needsStreet = needsAddress.value;

  await getPriceExists();

  if (needsAddress.value !== needsStreet) {
    return;
  }

  let params: Record<string, string> = {
    stadt: options.city as string,
  };

  if (needsAddress.value) {
    params = {
      ...params,
      strasse: options.street as string,
      hausnummer: options.houseNumber as string,
    };
  }

  if (options.oeko) {
    params.oeko = '1';
  }

  if (options.business) {
    params.gewerbe = '1';
  }

  if (options.productId) {
    params.pid = `${options.productId}`;
  }

  if (options.heating) {
    params.subCategories = `${options.heating}`;
  }

  if (options.typeOfMeasurement) {
    params.typeOfMeasurement = `${options.typeOfMeasurement}`;
  }

  const trimmedAffiliateId = `${props.affiliateId || ''}`.trim();

  if (trimmedAffiliateId !== '') {
    params.aid = trimmedAffiliateId;
  }

  const trimmedLz = `${props.lz || ''}`.trim();

  if (trimmedLz !== '') {
    params.lz = trimmedLz;
  }

  const trimmedPg = `${props.pg || ''}`.trim();

  if (trimmedPg !== '') {
    params.pg = trimmedPg;
  }

  const trimmedExitPopupUrl = `${props.epu || ''}`.trim();

  if (trimmedExitPopupUrl !== '') {
    params.epu = trimmedExitPopupUrl;
  }

  const trimmedPid = `${props.pid || ''}`.trim();

  if (trimmedPid !== '') {
    params.pid = trimmedPid;
  }

  const urlParams = new URLSearchParams(params);

  const usagePath = isHeatingPower.value && options.typeOfMeasurement !== 'single'
    ? `${options.usageNt}/${options.usageHt}`
    : options.usage;

  window.location.href = `${path}/${options.branch.slug}/${options.postcode}/${usagePath}/?${urlParams.toString()}`;
};

const size = reactive({
  value: null as string | null,
  class: null as string | null,
});

const setBranchSize = () => {
  if (branchesEl.value) {
    const branchHeightCols = branchesEl.value.querySelectorAll('.col-auto');
    branchHeightCols.forEach((heightCol) => {
      const $heightCol = heightCol as HTMLElement;
      $heightCol.style.height = '0px';
    });

    if (size.value === 'lg') {
      const branchesHeight = branchesEl.value.offsetHeight;
      branchHeightCols.forEach((heightCol) => {
        const $heightCol = heightCol as HTMLElement;
        $heightCol.style.height = `${branchesHeight / branchOptions.value.length}px`;
      });
    }
  }
};

watch(() => `${options.postcode}`.length === 5 && options.selectableCities.length > 0, () => {
  nextTick(() => {
    setBranchSize();
  });
});

const setSizeClass = () => {
  if (root.value) {
    if (root.value.offsetWidth >= 840) {
      size.value = 'lg';
    } else {
      size.value = 'sm';
    }

    size.class = `calculator--${size.value}`;

    if (product.value) {
      size.class += ' calculator--product';
    }
  }
};

const branchSelectionHeight = ref({ height: 0 });

const onResize = () => {
  setSizeClass();
  setBranchSize();
  for (let i = 100; i < 2000; i += 100) {
    setTimeout(() => {
      setSizeClass();
      setBranchSize();
    }, i);
  }

  if (branchSelection.value) {
    branchSelectionHeight.value.height = branchSelection.value.$el.offsetHeight;
  }
};

onBeforeMount(() => {
  if (['null', '', null, undefined].indexOf(props.productId as string) < 0) {
    ProductAPI.get(parseInt(props.productId as string, 10))
      .then((apiProduct) => {
        product.value = apiProduct;

        if (apiProduct) {
          options.branch = apiProduct.branch || 'power';
        }

        onResize();
      });
  }
});

watch(() => branchOptions.value, (b: BranchInterface[]) => {
  if (!options.branch && b.length) {
    const newSelectedBranch = b[0];
    options.branch = newSelectedBranch;
    onResize();
  }
}, {
  deep: true,
});

onMounted(() => {
  window.addEventListener('resize', onResize);
  window.addEventListener('load', onResize);
  onResize();
  setBranchSize();
  setTimeout(onResize, 250);
  setTimeout(onResize, 500);
  setTimeout(onResize, 750);
  setTimeout(onResize, 1000);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
  window.removeEventListener('load', onResize);
});

watch(() => options.selectableStreets.length, () => {
  nextTick(setBranchSize);
});

const classes = computed(() => {
  const classesArr = [
    size.class,
    `calculator--${props.type}`,
    options.isFetching ? 'fetching' : null,
  ];

  if (`${options.postcode}`.length === 5 && streetsOptions.value.length) {
    classesArr.push('expanded');
  }

  if (`${props.labelExtra || ''}`.length) {
    classesArr.push('has-label-extra');
  }

  if (props.heroLayout) {
    classesArr.push('is-hero-layout');
  }

  return classesArr;
});

const styles = computed(() => ({
  'margin-top': props.heroLayout ? `-${branchSelectionHeight.value.height}px` : null,
}));

const showCompanyTooltip = computed(() => options.branch.slug === 'strom');

return (_ctx: any,_cache: any) => {
  return (options.branch)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["calculator-v2", classes.value]),
        style: _normalizeStyle(styles.value),
        ref_key: "root",
        ref: root
      }, [
        _createVNode(BaseCalculatorV2BranchSelect, {
          ref_key: "branchSelection",
          ref: branchSelection,
          branches: branchOptions.value,
          modelValue: options.branch,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((options.branch) = $event))
        }, null, 8, ["branches", "modelValue"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(BaseSpacer),
          _hoisted_2,
          _createVNode(BaseSpacer),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(InputField, {
                label: "Deine Postleitzahl",
                "only-numeric": "",
                "error-numeric": "Ungültige Postleitzahl",
                "max-length": 5,
                "min-length": 5,
                modelValue: options.postcode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((options.postcode) = $event)),
                error: postcodeError.value
              }, null, 8, ["modelValue", "error"])
            ]),
            (`${options.postcode}`.length === 5 && streetsOptions.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(SelectField, {
                    label: "Deine Stadt*",
                    modelValue: options.city,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((options.city) = $event)),
                    disabled: options.selectableCities.length <= 1,
                    options: getCitiesOptions(options.selectableCities)
                  }, null, 8, ["modelValue", "disabled", "options"])
                ]))
              : _createCommentVNode("", true),
            (`${options.postcode}`.length === 5 && streetsOptions.value.length && needsAddress.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(SelectField, {
                    label: "Straße*",
                    modelValue: options.street,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((options.street) = $event)),
                    options: streetsOptions.value,
                    search: ""
                  }, null, 8, ["modelValue", "options"])
                ]))
              : _createCommentVNode("", true),
            (`${options.postcode}`.length === 5 && streetsOptions.value.length && needsAddress.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(InputField, {
                    label: "Hausnummer*",
                    type: "text",
                    modelValue: options.houseNumber,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((options.houseNumber) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (`${options.postcode}`.length === 5 && streetsOptions.value.length && !isHeatingPower.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(Checkbox, {
                    modelValue: options.business,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((options.business) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Gewerbekunde? "),
                      (showCompanyTooltip.value)
                        ? (_openBlock(), _createBlock(Tooltip, { key: 0 }, {
                            title: _withCtx(() => [
                              _createTextVNode(" Bis zu einem Jahresverbrauch von 10.000 kWh können Gewerbekunden einen unserer Privatkundentarife abschließen. ")
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_unref(FontAwesomeIcon), {
                                icon: "fa-solid fa-circle-info",
                                class: "text-primary"
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (isHeatingPower.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(SelectField, {
                    label: "Deine Heizung",
                    modelValue: options.heating,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((options.heating) = $event)),
                    options: heatOptions.value
                  }, null, 8, ["modelValue", "options"])
                ]))
              : _createCommentVNode("", true),
            (isHeatingPower.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(), _createBlock(SelectField, {
                    key: typeOfMeasurementOptions.value,
                    label: "Dein Stromzähler",
                    modelValue: options.typeOfMeasurement,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((options.typeOfMeasurement) = $event)),
                    options: typeOfMeasurementOptions.value,
                    image: ""
                  }, null, 8, ["modelValue", "options"]))
                ]))
              : _createCommentVNode("", true),
            (isHeatingPower.value && (options.typeOfMeasurement === 'doubleTariffWithoutHouseholdPower' || options.typeOfMeasurement === 'doubleTariffWithHouseholdPower'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(InputField, {
                    label: "Dein Jahresverbrauch in kWh",
                    "only-numeric": "",
                    modelValue: options.usageHt,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((options.usageHt) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (isHeatingPower.value && (options.typeOfMeasurement === 'doubleTariffWithoutHouseholdPower' || options.typeOfMeasurement === 'doubleTariffWithHouseholdPower'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(InputField, {
                    label: "Dein Jahresverbrauch in kWh",
                    "only-numeric": "",
                    modelValue: options.usageNt,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((options.usageNt) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (`${options.postcode}`.length === 5 && streetsOptions.value.length && !isHeatingPower.value || options.typeOfMeasurement === 'single')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(BaseCalculatorUsageField, {
                    label: "Dein Verbrauch*",
                    modelValue: options.usage,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((options.usage) = $event)),
                    branch: options.branch,
                    onChangeIcon: emitChangeIcon,
                    borderless: false,
                    business: !!options.business
                  }, null, 8, ["modelValue", "branch", "business"])
                ]))
              : _createCommentVNode("", true),
            (options.showStreetMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(BaseButton, {
                align: "center",
                width: "full",
                disabled: !canSubmit.value,
                onClick: _withModifiers(submit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.buttonLabel), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]),
          _createVNode(BaseSpacer),
          _createVNode(BaseSpacer)
        ])
      ], 6))
    : _createCommentVNode("", true)
}
}

})